import React, { createContext, useEffect, useState } from 'react';
import environment from 'environment';
import Amplify, { Auth } from 'aws-amplify';
import * as qs from 'query-string';
import { useLocation } from 'react-router-dom';
import { storeValue } from '../utils';

export const AuthContext = createContext();
Amplify.configure({
  Auth: {
    region: environment.awsRegion,
    userPoolId: environment.userPoolId,
    userPoolWebClientId: environment.userPoolWebClientId,
    oauth: {
      domain: environment.cognitoDomain,
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: environment.cognitoRedirectUrl,
      redirectSignOut: environment.cognitoRedirectUrl,
      responseType: 'token',
    },
  },
});

const AuthContextProvider = ({ children }) => {
  const [username, setUsername] = useState(null);
  const [jwtToken, setJwtToken] = useState(null);

  const location = useLocation();
  const getCurrentSession = async () => {
    try {
      const userSession = await Auth.currentSession();
      if (userSession?.isValid()) {
        const token = userSession.getIdToken();
        const { given_name, family_name } = token.payload;
        setUsername(`${given_name} ${family_name}`);
        setJwtToken(token.jwtToken);
      }
    } catch (error) {
      storeValue('queryParams', qs.parse(location.search));
      await Auth.federatedSignIn();
    }
  };

  useEffect(() => {
    getCurrentSession();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <AuthContext.Provider value={{ username, jwtToken }}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
